<script>
    import { _ } from "../services/i18n"
    import ButtonGroup from "./ButtonGroup.svelte";
    import InputField from "./InputField.svelte";
    import { afterUpdate, createEventDispatcher, onMount } from "svelte";
    const dispatch = createEventDispatcher();

    export let data = [];
    export let columns = null;
    export let showButtons = true;
    export let addButton = false;
    export let acceptLabel = null;
    export let cancelLabel = null;
    export let clearOnCancel = true;

    let restoreData = null;
    export let dataChanged = false;

    $: columnData = columns !== null ? 
        columns :
        data.length > 0 && Object.keys(data[0]).reduce((accum, key) => {
            return { ...accum, [key]: { type: typeof(data[0][key]), editable: true, fieldName: key }}
        }, {}) || {};

    function searchItemHover(evt) {
        dispatch("searchItemHover", evt.detail);
    }

    function searchItemOut() {
        dispatch("searchItemOut");
    }

    function updateItem(item, fieldName, newVal, searchData) {
        dispatch("itemChanged", { item, fieldName, newValue: newVal, searchData })
        if (restoreData === null) {
            restoreData = JSON.parse(JSON.stringify(data));
        }
        // TODO: Se pueden hacer comprobaciones de cosas como claves primarias
        item[fieldName] = newVal
        
        // Esto se hace para forzar a Svelte la recarga del contenido de la tabla
        data = data;
        dataChanged = true;
    }

    function cancelItem(item, fieldName) {
        if (clearOnCancel) {
            data = data.filter(dataItem => {
                return dataItem[fieldName] !== "";
            });
            dataChanged = true;
        }
        dispatch("itemCancel");
    }

    function saveData() {
        dataChanged = false;
        restoreData = null;
        dispatch('change', data);
    }

    function cancelData() {
        if (dataChanged) {
            data = restoreData;
        }
        data = data;
        restoreData = null;
        dataChanged = false;
        dispatch("cancel");
    }

    let editRow = -1;
    export let editItem = null;
    export const lockEditRow = (item) => {
        editRow = data.indexOf(item);
        editItem = item;
    }
    export const unlockEditRow = () => {
        editRow = -1;
        editItem = null;
    }
    export const accept = () => {
        saveData();
    }
    export const cancel = () => {
        cancelData();
    }

    let itemAdded = false;
    function addButtonPressed(evt) {
        itemAdded = true;
        dispatch("addItem", {});
    }

    afterUpdate(() => {
        // Vamos al último elemento de items
        // Si primer campo editable del elemento está vacío, activamos el foco
        // Esto lo hacemos para detectar si se ha añadido una fila nueva
        if (!itemAdded) return;
        itemAdded = false;
        const lastItem = data.length && data[data.length - 1];
        if (lastItem) {
            for (const key in lastItem) {
                const colData = Object.values(columnData).find(({fieldName}) => fieldName === key);
                if (colData && colData.editable && !lastItem[colData.fieldName]) {
                    const input = document.getElementById(`field_${colData.fieldName}_${data.length - 1}`);
                    if (input) {
                        input.focus();
                    }
                    break;
                }
            }
        }
    })
    
</script>


<section>
    {#if editRow !== -1}
        <div class="block-actions"></div>
    {/if}
    <div class={(showButtons ? `table-container` : 'table-container no-buttons') + (editRow !== -1 ? " locked-table" : "")}>
        <table class={editRow !== -1 ? "locked-table" : ""}>
            <thead>
                <tr>
                    {#each Object.entries(columnData) as [key,data]}
                        <th>{$_(key)}</th>
                    {/each}
                </tr>
            </thead>
            <tbody>
                {#each data as item, itemIndex}
                    <tr class={itemIndex === editRow ? "edit-row" : ""}>
                        {#each Object.entries(columnData) as [key,data]} 
                            {#if data.type === "actions"}
                                <td class="actions-field">
                                    {#each Object.entries(data.actions) as [actionName,actionData]}
                                        {#if  (actionData.isEnabled !== undefined && actionData.isEnabled(item)) || actionData.isEnabled === undefined }
                                            <button on:click={() => actionData.callback(item)}>
                                                {#if actionData.icon}
                                                    <img class="icon-image" src={actionData.icon} alt={actionName}/>
                                                {:else }
                                                    {actionName}
                                                {/if}
                                            </button>
                                        {:else}
                                            <button class="disabled">
                                                {#if actionData.icon}
                                                    <img class="icon-image" src={actionData.icon} alt={actionName}/>
                                                {:else }
                                                    {actionName}
                                                {/if}
                                            </button>
                                        {/if}
                                    {/each}
                                </td>
                            {:else if data.dataSourceCallback}
                                <td class="search-field">
                                    <InputField 
                                        id={`field_${data.fieldName}_${itemIndex}`}
                                        editable={data.editable}
                                        value={item[data.fieldName]} 
                                        type={data.type}
                                        max={data.max}
                                        min={data.min}
                                        searchDataCallback={async () => {
                                            const searchData = await data.dataSourceCallback(item);
                                            return searchData;
                                            //data.dataSourceCallback();
                                        }}
                                        searchDataVisibleFields={data.dataSourceVisibleFields}
                                        searchKey={data.dataSourceKey}
                                        on:change={(evt) => updateItem(item, data.fieldName, evt.detail.value, evt.detail.searchData)}
                                        on:cancel={evt => cancelItem(item, data.fieldName)}
                                        on:searchItemHover={e => searchItemHover(e)}
                                        on:searchItemOut={() => searchItemOut()}/>
                                </td>
                            {:else if data.dataSource}
                                <td class="search-field">
                                    <InputField 
                                        id={`field_${data.fieldName}_${itemIndex}`}
                                        editable={data.editable}
                                        value={item[data.fieldName]} 
                                        type={data.type}
                                        searchData={data.dataSource}
                                        searchDataCallback={data.dataSourceCallback}
                                        searchDataVisibleFields={data.dataSourceVisibleFields}
                                        searchKey={data.dataSourceKey}
                                        max={data.max}
                                        min={data.min}
                                        on:change={(evt) => updateItem(item, data.fieldName, evt.detail.value, evt.detail.searchData)}
                                        on:cancel={evt => cancelItem(item, data.fieldName)}/>
                                </td>
                            {:else}
                                <td class="no-search-field">
                                    <InputField 
                                        id={`field_${data.fieldName}_${itemIndex}`}
                                        editable={data.editable}
                                        value={item[data.fieldName]} 
                                        type={data.type} 
                                        max={data.max}
                                        min={data.min}
                                        on:change={(evt) => updateItem(item, data.fieldName, evt.detail.value, evt.detail.searchData)}
                                        on:cancel={evt => cancelItem(item, data.fieldName)}/>
                                </td>
                            {/if}
                        {/each}
                    </tr>
                {/each}
                {#if addButton}
                    <tr>
                        <td>
                            <button class="add-button" on:click={addButtonPressed}>{$_("orderEdit_add")}</button>
                        </td>
                    </tr>
                {/if}
            </tbody>
        </table>
    </div>
    {#if showButtons}
        <ButtonGroup
            actions={{
                "ui_buttons_accept": () => saveData(),
                "ui_buttons_cancel": () => cancelData()
            }}
            disabled={{
                "ui_buttons_accept": dataChanged !== true
            }}
            labels={{
                "ui_buttons_accept": acceptLabel,
                "ui_buttons_cancel": cancelLabel
            }} />
    {/if}
</section>

<style>
    section {
        position: relative;
    }

    div.block-actions {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        background-color: rgba(255, 255, 255, 0.4);
        z-index: 1;
    }
    /*table.locked-table {
        background-color: lightgray;
    }*/

    section {
        height: 100%;
        width: 100%;
    }
    div.table-container {
        border-top: 1px solid #1b3258;
        border-left: 1px solid #1b3258;
        border-right: 1px solid #1b3258;
        border-bottom: 1px solid #1b3258;
        border-radius: 3px;
        height: calc(100% - 55px);
        width: 100%;
        overflow: auto;
    }

    div.table-container.locked-table {
        background-color: lightgray;
    }

    div.table-container.no-buttons {
        height: 100%;
    }

    table {        
        width: 100%;
    }

    thead {
        position: sticky;
        top: 0px;
        width: 100%;
        background-color: var(--theme-color-4);
        color: white;
    }

    tbody {
        width: 100%;
    }

    .icon-image {
        width: 20px;
        height: 20px;
    }

    th {
    text-align: center;
    letter-spacing: 1.5px;
    font-weight: 400;
    padding: 5px;
    text-transform: uppercase;
    
   
    
    }

    tr.edit-row {
        background-color: var(--theme-color-1);
    }

    td.actions-field {
        display: flex;
        justify-content: center;;
        flex-wrap: nowrap;
        gap: 5px;
    }

    button {
        margin-bottom: 0px;
    }

    button.add-button {
        min-width: 100px;
        color: white;
        background: #36a9e1;
        border-radius: 5px;
        border: none;
        margin: 15px;
        letter-spacing: 1.5px;
        padding: 10px;
    }

    button.add-button:hover {
        background-color: #1b3258;
    }

    button.disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

</style>

<svelte:head>
    <link rel="stylesheet" href="styles/ui/tables.css" />
</svelte:head>